import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import CustomLoader from '../common/CustomLoader';
import { CustomComponentEditForm } from './custom-component/CustomComponentEditForm';
import { CustomComponentForm } from './custom-component/CustomComponentForm';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import { checkCustomComponentPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
import { isProjectReadOnly } from '../../common/utils/api_utils';

export class CustomComponentEditPage extends Component {
  static propTypes = {
    customComponent: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { activeTab: 'customComponent', customComponentId: '' };

  componentDidMount = () => {
    const { match, actions } = this.props;
    const { projectId, version, customComponentId } = match.params;
    actions.loadProjectDetailCustomComponent({ projectId, version });
    actions.loadCustomComponentConfigs({ projectId, version });
    actions.loadCustomComponentConfig({ projectId, version, customComponentId });
    if (customComponentId) this.setState({ customComponentId });
  };

  componentDidUpdate(prevProps) {
    const { projectDetail } = this.props.customComponent;
    if (prevProps.customComponent.projectDetail !== projectDetail) {
      if (projectDetail && projectDetail.projectType) {
        const { projectType } = projectDetail;
      }
    }
  }

  componentMenuToggle = (activeTab) => {
    const { match, history } = this.props;
    const { projectId, version } = match.params;
    this.setState({ activeTab });
    history.push(`/custom-component/${version}/v/${projectId}/${activeTab}`);
  };

  appSettingToggle = (activeTab) => {
    const { history, match } = this.props;
    const { projectId, version } = match.params;
    history.push(`/app-setting/${version}/v/${projectId}/setting/${activeTab}`);
  };

  aiModelToggle = (activeTab) => {
    const { history, match } = this.props;
    const { projectId, version } = match.params;
    history.push(`/app-setting/${version}/v/${projectId}/setting/${activeTab}`);
  };

  render() {
    const isAllowed = checkCustomComponentPermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent containerClassName="customComponent">
          <PermissionDenied message="Custom Component" />
        </CommonPageComponent>
      );
    }
    const { match, customComponent, home, history, actions } = this.props;
    const {
      projectDetail,
      currentCustomComponent,
      loadProjectDetailCustomComponentPending,
      loadCustomComponentConfigPending,
    } = customComponent;
    const { customComponentId, activeTab } = this.state;
    console.log('THis is the customComponentID: ', customComponentId);
    const { collections, pages, events } = home;
    const { projectId, version } = match.params;
    const isReadOnly = isProjectReadOnly(projectId);
    if (loadProjectDetailCustomComponentPending || !projectDetail) {
      return (
        <CommonPageComponent parentClassName="">
          <div className="row mx-auto">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-center">
              <CustomLoader
                loading={loadProjectDetailCustomComponentPending}
                size="20px"
                color="#303453"
              />
            </div>
          </div>
        </CommonPageComponent>
      );
    }

    return (
      <CommonPageComponent containerClassName="customComponent">
        <AppSettingsNav
          activeTab={activeTab}
          projectDetail={projectDetail}
          advanceAppConstantToogle={this.appSettingToggle}
          customComponentMenuToogle={this.componentMenuToggle}
          CustomCSSJSMenuToogle={this.appSettingToggle}
          SnapshotMenuToogle={this.appSettingToggle}
          AIModelMenuToggle={this.aiModelToggle}
        />
        {customComponentId ? (
          <CustomComponentEditForm
            projectId={projectId}
            version={version}
            history={history}
            component={currentCustomComponent}
            customComponentId={customComponentId}
            collections={collections}
            projectDetail={projectDetail}
            pages={pages}
            events={events}
            loadCustomComponentConfigPending={loadCustomComponentConfigPending}
            actions={actions}
            isReadOnly={isReadOnly}
          />
        ) : (
          <CustomComponentForm
            projectId={projectId}
            version={version}
            history={history}
            addCustomComponentConfig={actions.addCustomComponentConfig}
            isReadOnly={isReadOnly}
          />
        )}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    customComponent: state.customComponent,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomComponentEditPage);
